export const stayProperties = {
  georgia: {
    destination: 'Georgia', bedrooms: '', bathrooms: '', amenities: ['Circular driveway', 'Washer and dryer'], petFee: 50,
    id: 'georgia', name: 'Valdosta, Georgia', path: '/stay/valdosta',
    image: 'bannersamll.jpg', alt: 'Landscaped greenery beneath oak trees in Georgia',
    title: ['A welcoming base', 'in Valdosta.'],
    location: '309 Rosedale Place · Valdosta, GA 31602',
    introduction: 'A convenient place to settle in, near SGMC, Valdosta State University and local attractions.',
    overview: 'Near SGMC · Near VSU · Circular driveway',
    // Airbnb listing supplied by the owner: House rules, 4 guests maximum.
    maxGuests: 4,
    gallery: Array.from({ length: 16 }, (_, index) => `${process.env.PUBLIC_URL}/images/${index + 1}.jpeg`),
    rates: { weekday: 150, weekend: 170 },
    airbnb: 'https://www.airbnb.com/rooms/1565968253581888363?guests=1&adults=1&s=67&unique_share_id=4c760311-a9f2-429b-a1f9-b739286d2534',
  },
  jamaica: {
    destination: 'Jamaica', bedrooms: 1, bathrooms: 1, amenities: ['Kitchen'], petFee: 50,
    gallery: ['jamaica-1.png', 'jamaica-2.png'].map(image => `${process.env.PUBLIC_URL}/images/${image}`),
    id: 'jamaica', name: 'St Mary, Jamaica', path: '/stay/st-mary',
    image: 'jamaica-1.png', alt: 'A calm beach in Jamaica beneath coastal trees',
    title: ['A little island time.', 'A place of your own.'],
    location: 'St Mary, Jamaica',
    introduction: 'Find your island rhythm. A little more time for yourself, with one bedroom, one bathroom and a kitchen.',
    overview: '1 bedroom · 1 bathroom · Kitchen',
    rates: { weekday: 160, weekend: 170 },
    intro: 'Slow down in St Mary and make a little room for island time. With one bedroom, one bathroom and a kitchen, this Jamaica stay offers a place to settle in and enjoy your own rhythm.',
    more: 'Whether you’re planning a getaway or a longer visit, tell your host what brings you to Jamaica. Share your preferred dates and the details that would help make the stay feel right for you.',
    facts: [
      ['A place of your own', 'One bedroom, one bathroom and a kitchen form the essentials of your St Mary stay. Ask your host about sleeping arrangements and the full amenities list.'],
      ['Find your island rhythm', 'Make time for a slower morning or a day of exploring. Ask your host for suggestions around St Mary that suit your plans.'],
      ['Plan your arrival', 'Contact your host for the exact address, arrival instructions and advice on getting to the property before you travel.'],

    ],
    explore: [
      ['Island time', 'Leave room in your plans for a slower pace and a little time for yourself.'],
      ['Around St Mary', 'Ask your host for local suggestions and help planning your days.'],
      ['A taste of Jamaica', 'Discover local flavours and ask your host about places to eat during your visit.'],
      ['Your kind of getaway', 'Share what you enjoy and ask for ideas to make the most of your time in Jamaica.'],
    ],
  },
  oregon: {
    id: 'oregon', name: 'Hillsboro, Oregon', destination: 'Oregon', path: '/stay/oregon',
    comingSoon: true,
    bedrooms: 4, bathrooms: 2, amenities: ['Gated back yard', 'Washer and dryer', 'Central heat and air', 'Stove, microwave and dishwasher'], petFee: 50,
    image: 'aaa.jpg', gallery: [], alt: 'Hillsboro property exterior with a front porch and two-car garage', rates: { weekday: null, weekend: null },
    title: ['A little time away.', 'Discover Oregon.'], location: 'Hillsboro, Oregon',
    introduction: 'Make time to rest, recharge and explore Oregon at your own pace.',
    overview: '4 bedrooms · 2 bathrooms',
    intro: 'Plan a comfortable getaway in Hillsboro, Oregon, with space to pause between local experiences.',
    more: 'Enjoy a gated back yard, washer and dryer, central heat and air, and a stove, microwave and dishwasher. Contact your host for rates and availability.',
    facts: [],
  },
};

export const bookingHref = (id, range = {}) => `/booking?${new URLSearchParams({ destination: id, ...(range.start ? { checkIn: range.start } : {}), ...(range.end ? { checkOut: range.end } : {}) })}`;
